// eslint-disable-next-line no-restricted-imports
import { setup, type ApiV2Token } from '@pi/api-client';
import memoizeOne from 'memoize-one';
import { getEnvVariables, type EnvVars } from 'src/utils/envConfig';

function setupApiClient(jwt: ApiV2Token, name: string, env: EnvVars = getEnvVariables()) {
    setup({
        apiV2Token: jwt,
        apiV2Url: env.apiV2Url,
        tracking: {
            type: 'browser',
            name,
            host: location.hostname,
        },
    });
}

export default memoizeOne(setupApiClient);
